import React from 'react';
import { connect } from 'react-redux';

import { isChrome } from '../../util/env';

const BrowserCheck = props =>  !isChrome() && <section className="header-cell browesr-check-cell">
    <i className={`mblock-icon icon-warn`}></i>
    {props.intlr.messages['BROWSER.COMPATIBLE_TIP']}
</section>;

export default connect(state => ({intlr: state.intlr}))(BrowserCheck);